<div class="bdo-container bdo-space--bottom">
  <h3>{{ 'password.forgot.title' | translate }}</h3>
</div>

<div class="bdo-container--single">

  <div class="bdo-space--bottom">
    {{ 'password.forgot.description' | translate }}
  </div>

  @if (errorShown) {
    <div>
      <bdo-info-box>
        {{ 'password.forgot.error.default' | translate }}
      </bdo-info-box>
    </div>
  }

  <form class="bdo-form-container" (ngSubmit)="send()" [attr.aria-label]="'aria.form.passwordReset' | translate">
    @if (sendingData) {
      <bdo-loading></bdo-loading>
    }
    <fieldset name="password-reset" [attr.aria-label]="'aria.fieldset.loginCredentials' | translate">
      <div class="bdo-form-item-container">
        <bdo-input
          [id]="'username'"
          [attr.data-qa]="'username'"
          [formControl]="$any(forgotPasswordForm.get('username'))"
          [labelText]="'register.username.title' | translate"
          [placeholder]="'register.username.title' | translate"
          [tooltipContent]="'password.forgot.usernameInfo' | translate"
          >
        </bdo-input>
      </div>
      <div>
        <button class="bdo-button-primary bdo-button--text re-mb-30" type="submit"
          [disabled]="sendingData" >
          {{ 'general.action.submit' | translate }}
        </button>
        <a class="bdo-nolink" [routerLink]="['/login']" data-qa="cancel">
          <div class="bold"> {{ 'general.action.cancel' | translate }}</div>
        </a>
      </div>
    </fieldset>
  </form>

</div>


<bdo-simple-text-popup [isVisible]="mailSent" (closePopupEvent)="closeMessage()"
  [title]="'password.forgot.success.title' | translate" [icon]="'success'">
  <div class="popup--success">
    {{ 'password.forgot.success.description' | translate }}
  </div>
</bdo-simple-text-popup>
